import { Functions } from "../Config/Fire";

export async function get_comune(id_comune) {
  const comune = Functions.httpsCallable("comune-getDatiComune");
  return await comune(id_comune);
}
